<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">一般负面舆情</div>
        <div class="branch">-0.3</div>
      </div>
      <div class="tip">
        <div class="con">大理州-大理市</div>
        <div class="con">一类地区</div>
      </div>
      <div class="date">2019-11-01 12:31:22</div>
    </div>
    <div class="pg-pd12">
      <div>
        <causeDeduction :causeContent="causeContent" />
      </div>
      <!-- 舆情详情 -->
      <div class="main">
        <div class="title">舆情详情</div>
        <div class="content">
          <div class="item">
            <div class="name">舆情标题</div>
            <div class="text">{{opinionInfo.opinionTitle}}</div>
          </div>
          <div class="item">
            <div class="name">问题分类</div>
            <div class="text">{{opinionInfo.opinionType}}</div>
          </div>
          <div class="item">
            <div class="name">舆情级别</div>
            <div class="text">{{opinionInfo.opinionLevel}}</div>
          </div>
          <div class="item">
            <div class="name">网络走势</div>
            <div class="text">{{opinionInfo.netTend}}</div>
          </div>
          <div class="hide">
            <div class="item">
              <div class="name">信息来源</div>
              <div class="text">{{opinionInfo.infoSource}}</div>
            </div>
            <div class="item1">
              <div class="name">信息链接</div>
              <div class="link">{{opinionInfo.infoUrl}}</div>
            </div>
            <div class="item">
              <div class="name2">是否涉及多个州市</div>
              <div class="text">{{opinionInfo.multiArea}}</div>
            </div>
            <div class="item">
              <div class="name2">州市扣分占比</div>
              <div class="text">{{opinionInfo.deducRate}}%</div>
            </div>
            <div class="item1">
              <div class="name">主要内容</div>
              <div class="text">
                {{opinionInfo.opinionDesc}}
              </div>
            </div>
          </div>
          <div class="btn" :class="isDescStatus?'':' on'" @click="showmoreDesc($event)">
            <span>{{!this.isDescStatus ? '收起' : '展开'}}</span>
          </div>
        </div>
      </div>
      <!-- 相关材料 -->
      <materialScience :caseList="assessFile" :id="id" />
    </div>
  </div>
</template>
<script>
  // import Vue from 'vue';
    import causeDeduction from './components/causeDeduction'; // 扣分原因
    import materialScience from './components/materialScience'; // 相关材料
    import api from '../../service/modules/appraise';
    import {} from 'vant';
    // Vue.use(Picker);
    export default {
        components: {
            causeDeduction,
            materialScience
        },

        data () {
            return {
                isDescStatus: true,
                id: '1',
                caseList: [{
                               id: '1',
                               title: '文化和旅游',
                               type: 'pdf'
                           },
                           {
                               id: '2',
                               title: '公安一',
                               type: 'doc'
                           },
                           {
                               id: '2',
                               title: '公安一',
                               type: 'exl'
                           }
                ],
                causeContent: '接到游客投诉未在5分钟内响应',
                // 相关材料列表
                assessFile: [
                    { fileName: '文化和旅游', fileType: 'pdf', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' },
                    { fileName: '公安一', fileType: 'doc', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' },
                    { fileName: '公安一', fileType: 'exl', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' }
                ],
                opinionInfo: {
                    opinionTitle: '强迫游客购物',
                    opinionType: '导游变相强迫游客购物',
                    opinionLevel: '三级负面舆情',
                    netTend: '微博热搜',
                    infoSource: '新浪微博',
                    infoUrl: 'https://www.baidu.com',
                    multiArea: '是',
                    deducRate: '33',
                    opinionDesc: '一个云南导游辱骂游客、称游客骗吃骗喝的视频曾在网上引发……'
                }
            }
        },

        computed: {},

        watch: {},

        methods: {
            // 考核明细接口
            getSubAssessDetail () {
                api.getAssessDetailById({ id: '335C6B06-33CA-D7E4-B539-C35B6B9BA99E', complainId: '201907141721243498431', subType: 'A1' }).then(res => {
                    if (res.ret === 0) {
                        this.assessDetail = res.data.assessDetail
                        this.causeContent = res.data.assessDetail.deductionReason// 扣分原因
                        this.opinionInfo = res.data.assessDetail.opinionInfo
                    } else {
                        this.$Message.error(res.data.msg)
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoreList'
                })
            },
            showmoreDesc (e) {
                let el = e.currentTarget;
                el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('hide');
                // el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
                // el.innerHTML = !this.isDescStatus ? '展开' : '收起';
                this.isDescStatus = !this.isDescStatus;
                this.isShowMore = true;
            }
        },

        mounted () {},

        created () {}

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;

    .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }

    .head {
      width: 100%;
      background: #fff;
      padding: 24px 12px;
      margin-bottom: 24px;

      .title {
        height: 22px;
        line-height: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .text {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }

        .branch {
          height: 22px;
          font-size: 22px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: rgba(255, 77, 77, 1);
          line-height: 22px;
        }
      }

      .tip {
        margin-top: 12px;
        display: flex;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(54, 179, 116, 1);

        .con {
          border: 1Px solid rgba(54, 179, 116, 1);
          padding: 2px 4px;
          margin-right: 14px;
        }
      }

      .date {
        margin-top: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }
    }

    .main {
      margin-top: 24px;
      padding-bottom: 30px;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }

      .content {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-top: 12px;
        padding: 16px;
        .hide{
          display: none;
        }
        .item {
          display: flex;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          margin-bottom: 9px;
          line-height: 20px;

          .name {
            width: 72px;
            color: #999999;
          }
          .name2{
            width: 124px;
            color: #999999;
          }

          .text {
            color: #333333;
            word-break: break-all;
            flex: 1;
          }

          .red {
            color: #FF4D4D;
          }
        }

        .item:last-child {
          margin-bottom: 0;
        }
        .item1{
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          margin-bottom: 9px;
          line-height: 20px;
          .name{
            min-width: 72px;
            color: #999999;
          }
          .link{
            color:rgba(54,179,116,1);
            line-height: 22px;
            word-wrap:break-word;
          }
          .text {
            color: #333333;
            word-break: break-all;
            flex: 1;
          }
        }
      .btn{
      padding: 0 16px;
      text-align: center;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:14px;
      span{
        position: relative;
        padding-right: 11px;
      }
      span::after{
        content:'';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 4px;
          background: url(../../assets/image/jiantou.png) no-repeat;
          background-size: 6px 4px;
      }
    }
    .btn.on{
      span::after{
        content:'';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 4px;
          background: url(../../assets/image/jiantou.png) no-repeat;
          background-size: 6px 4px;
          transform: rotate(180deg);
      }
    }
      }
    }

  }
</style>
